import { render, staticRenderFns } from "./androidtask.vue?vue&type=template&id=cc95258c&scoped=true"
import script from "./androidtask.vue?vue&type=script&lang=js"
export * from "./androidtask.vue?vue&type=script&lang=js"
import style0 from "./androidtask.vue?vue&type=style&index=0&id=cc95258c&lang=scss&scoped=true"
import style1 from "./androidtask.vue?vue&type=style&index=1&id=cc95258c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc95258c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc95258c')) {
      api.createRecord('cc95258c', component.options)
    } else {
      api.reload('cc95258c', component.options)
    }
    module.hot.accept("./androidtask.vue?vue&type=template&id=cc95258c&scoped=true", function () {
      api.rerender('cc95258c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/firmware/androidtask.vue"
export default component.exports